import React, {useEffect, useState} from "react";
import {Modal} from "reactstrap";
import ModalBody from "reactstrap/es/ModalBody";
import {useDispatch, useSelector} from "react-redux";
import {loadHistoryItem} from "../../../../actions/historyActions";
import {getRusDateHourString} from "../../../../utils/dateUtils";
import SimpleTable from "../../../common/tables/SimpleTable";

export default function HistoryItemModal({id, onCloseModal}) {
    const dispatch = useDispatch();
    const historyItem = useSelector(state => state.historyReducer.historyItem);

    useEffect(() => {
        if (!id) {
            return;
        }
        dispatch(loadHistoryItem(id));
    }, [id]);
    return (
        <Modal className="ros-line-modal" isOpen={id !== null} toggle={() => onCloseModal()}>
            <ModalBody>
                { historyItem &&
                <div>
                    <h6 style={{textAlign: "center"}}>{historyItem.message}</h6>
                    <HistoryItemModalLine label={"Дата"} value={getRusDateHourString(new Date(historyItem.date))}/>
                    <HistoryItemModalLine label={"Автор"} value={historyItem.user?.name}/>
                    <HistoryItemModalLine label={"Аккаунт пользователя"} value={historyItem.forUser?.name}/>
                    <HistoryItemModalLine label={"IP"} value={historyItem.ip}/>
                    <HistoryItemModalLine label={"User-Agent"} value={historyItem.userAgent}/>
                    <br/>
                    {historyItem.description?.operations && <>
                        <h6 style={{textAlign: "center"}}>Действия:</h6>
                        {historyItem.description.operations.map((operation, idx) => <HistoryItemModalOperation idx={idx} operation={operation}/>)}
                    </>}
                </div>}
            </ModalBody>
        </Modal>
    )
}

const HistoryItemModalOperation = ({operation, idx}) => {
    return <p key={(idx + 1) + ". " + operation.name}>
        <b style={{color: "rgba(61,66,70,0.9)", fontSize: "13px"}}>
            {(idx + 1) + ". " + operation.name}
        </b>
        <HistoryItemModalProperties properties={operation.properties}/>
    </p>;
};

const HistoryItemModalProperties = ({properties}) => {

    if (!properties || properties.length === 0) {
        return null;
    }

    const tableColumns = () => {
        return [
            {
                name: "Параметр",
                key: "name",
                getBodyCellValue: property => property.name,
                bodyCellStyle: {textAlign: "center"},
            },
            {
                name: "Новое значение",
                key: "value",
                getBodyCellValue: property => property.value,
                bodyCellStyle: {textAlign: "center"},
            },
            {
                name: "Старое значение",
                key: "oldValue",
                getBodyCellValue: property => property.oldValue,
                bodyCellStyle: {textAlign: "center"},
            },
        ];
    };

    return  <SimpleTable
            tableClassName="table table-bordered nowrap statistic_table sticky-header sticky-action sticky-footer userselecttext"
            columns={tableColumns()}
            data={properties}
            bodyRowKey="name"/>;
};

const HistoryItemModalLine = ({label, value}) => {
    return <p><b style={{color: "rgba(61,66,70,0.9)"}}>{label}: </b>{value}</p>
};